import {createAction} from 'redux-act';
import {DomainConfig, Preferences} from '@/app/interfaces/preferences';

export const setPreferencesAction = createAction<Partial<Preferences>>('config/setPreferences');

export const setDomainConfigAction = createAction<DomainConfig>('config/setDomainConfig');

export const setNoAdsAction = createAction<boolean>('config/setNoAds');
